import { map, clamp, randomMinMax } from './../../js/utils/math.js';

export default class ContactDetails {
  init(root) {
    this.root = root;
    this.typedTextEl = root.querySelector('.typed-text');
    this.mailBackground = root.querySelector('.contact-mail-background');
    this.phone = root.querySelector('.contact-phone-number');
    this.cursorEl = root.querySelector('.cursor');
    this.toggleButton = root.querySelector('#toggle-animations-contactdetails');

    this.fullText = this.mailBackground.textContent.trim();
    this.currentIndex = 0;
    this.typingForward = true;
    this.typingSpeed = 100;
    this.typingInterval = null;
    this.vibrateInterval = null;
    this.animationsRunning = true;

    this.startAnimations();
    this.addEvents();
  }

  addEvents() {
    this.toggleButton.addEventListener('click', () => {
      if (this.animationsRunning) {
        this.stopAnimations();
        this.toggleButton.classList.add('is-paused');
        // this.toggleButton.textContent = 'Start Animations';
      } else {
        this.startAnimations();
        this.toggleButton.classList.remove('is-paused');
        // this.toggleButton.textContent = 'Stop Animations';
      }
    });
  }

  startAnimations() {
    this.typingInterval = setInterval(() => this.type(), this.typingSpeed);
    this.vibrateInterval = setInterval(() => this.vibratePhone(), 8500);
    this.animationsRunning = true;
  }

  stopAnimations() {
    clearInterval(this.typingInterval);
    this.typedTextEl.textContent = this.fullText; // Show full text when stopping
    this.cursorEl.classList.add('typing');
    this.currentIndex = this.fullText.length;
    this.typingForward = false;
    clearInterval(this.vibrateInterval);
    this.phone.classList.remove('vibrate');
    this.animationsRunning = false;
  }

  type() {
    // Check if the typing is paused
    if (this.pauseFlag) return; // If paused, return early
    
    if (randomMinMax(0,2) > 1) return; // Return early to create a pause effect

    // Add 'typing' class while typing, remove when waiting
    this.cursorEl.classList.add('typing');

    if (this.typingForward) {
      this.currentIndex++;
      if (this.currentIndex >= this.fullText.length) {
        this.typingForward = false;
        this.pauseFlag = true; // Start pause after typing forward
        this.cursorEl.classList.remove('typing'); // Blink cursor while paused
        setTimeout(() => {
          this.pauseFlag = false; // Allow typing to resume
        }, 5000);
      }
    } else {
      this.currentIndex--;
      if (this.currentIndex <= randomMinMax(2,7)) {
        this.typingForward = true;
        this.pauseFlag = true; // Start pause after typing backward
        this.cursorEl.classList.remove('typing'); // Blink cursor while paused
        setTimeout(() => {
          this.pauseFlag = false; // Allow typing to resume
        }, 1000);
      }
    }

    this.typedTextEl.textContent = this.fullText.substring(0, this.currentIndex);
  }


  vibratePhone() {
    this.phone.classList.add('vibrate');
    setTimeout(() => {
      this.phone.classList.remove('vibrate');
    }, 1200); // matches the vibration duration
  }
}
